import React from 'react';
import { Button, Dropdown, Form, Modal } from 'semantic-ui-react';
import { SelectField, TextField } from '../../common/FormFields';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import * as selectors from '../../../redux/selectors';
import * as actions from '../../../redux/actions';
import * as api from '../../../api/postApi';
import * as yup from 'yup';
import { equals } from 'ramda';
import { bindActionCreators } from 'redux';
import { buildOptionsFromArray } from '../../../utils/buildOptionsFromArray';

const AddArticleModal = ({ sites, getSites, addNewsItem }) => {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [sections, setSections] = React.useState([]);

  // Restaurants & Bars
  // City Life
  // Entertainment
  // Travel
  // Real Estate
  // Arts
  // Society
  // Home & Design
  // Fashion & Beauty
  // Innovation
  // Sports (hidden section)

  const getSortOrder = section => {
    const title = section.toUpperCase();
    switch (title) {
      case 'RESTAURANTS + BARS':
        return 0;
      case 'CITY LIFE':
        return 1;
      case 'ENTERTAINMENT':
        return 2;
      case 'TRAVEL':
        return 3;
      case 'REAL ESTATE':
        return 4;
      case 'ARTS':
        return 5;
      case 'SOCIETY':
        return 6;
      case 'HOME + DESIGN':
        return 7;
      case 'FASHION + BEAUTY':
        return 8;
      case 'INNOVATION':
        return 9;
      case 'SPORTS':
        return 10;
      default:
        return 99;
    }
  };

  const handleSiteChange = async siteId => {
    setLoading(true);
    const { sections } = await api.getSections(siteId);
    const news = sections?.find(s => s?.title?.toLowerCase() === 'news');
    const isNewsSections = ({ parent_id }) => equals(news?.id, parent_id);

    let sectionChoices = sections.filter(isNewsSections).sort((a, b) => getSortOrder(a.title) - getSortOrder(b.title));
    const options = buildOptionsFromArray(sectionChoices, 'title', 'id');
    setSections(options);
    setLoading(false);
  };

  const validationSchema = yup.object({
    siteId: yup.string().required('A site is required'),
    sectionId: yup.string().required('A section is required'),
    headline: yup.string().required('A headline is required'),
  });

  const handleSubmit = async (post, formik) => {
    addNewsItem({ ...post, type: 'page' });
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Formik
      initialValues={{ siteId: '', sectionId: '', headline: '' }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {formik => (
        <Modal
          size="small"
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          open={open}
          trigger={<Button icon="plus" labelPosition="left" positive content="Add Article" />}
        >
          <Modal.Header>Add Article</Modal.Header>
          <Modal.Content>
            <Form onSubmit={formik.handleSubmit} widths="equal">
              <Form.Group>
                <Form.Field>
                  <strong>City</strong>
                  <Dropdown
                    fluid
                    search
                    selection
                    clearable
                    options={sites || []}
                    id="siteId"
                    label="Site"
                    name="siteId"
                    value={formik.values.siteId}
                    onChange={(e, { name, value }) => {
                      formik.setFieldValue(name, value);
                      handleSiteChange(value);
                    }}
                    size="small"
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group>
                <SelectField
                  label="Section"
                  id="sectionId"
                  name="sectionId"
                  formik={formik}
                  loading={loading}
                  options={sections}
                  value={formik.values.sectionId}
                  onChange={formik.handleChange}
                />
              </Form.Group>
              <strong>Working Headline</strong>{' '}
              <span style={{ fontSize: '.8rem' }}>*Creates the slug for your article</span> <br />
              <Form.Group>
                <TextField
                  name="headline"
                  formik={formik}
                  value={formik.values.headline}
                  onChange={formik.handleChange}
                />
              </Form.Group>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              content="Submit"
              disabled={!formik.isValid}
              labelPosition="left"
              icon="save"
              onClick={formik.handleSubmit}
              positive
            />
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({
  sites: selectors.admin.cultureMapSiteOptions(state),
});

const mapDispatchToProps = dispatch => ({
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
  addNewsItem: bindActionCreators(actions.content.addNewsItem, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddArticleModal);
